import { HeartIcon } from '@/components/original/icons'
import { actionButtonClassName, PlayViewControls } from '@/components/play/PlayViewControls'
import { cn } from '@/lib/utils'
import { useAppDispatch, useAppSelector } from '@/store/hooks'
import { selectIsOriginalFavorite, toggleFavorite } from '@/store/slices/originalSlice'

interface OriginalPlayActionBarProps {
	gameId: string
	gameName: string
	onFullscreen: () => void
	onTheaterToggle: () => void
	isTheaterMode: boolean
}

export function OriginalPlayActionBar({ gameId, gameName, onFullscreen, onTheaterToggle, isTheaterMode }: OriginalPlayActionBarProps) {
	const dispatch = useAppDispatch()
	const isFavorite = useAppSelector(selectIsOriginalFavorite(gameId))

	const handleFavoriteClick = () => {
		dispatch(toggleFavorite(gameId))
	}

	return (
		<div className='flex flex-wrap items-center justify-between gap-3 rounded-xl border border-border bg-card px-3 py-2.5 sm:px-4'>
			<button
				type='button'
				onClick={handleFavoriteClick}
				className={cn(actionButtonClassName, isFavorite && 'border-primary/40 bg-primary/10 text-primary')}
				aria-label={isFavorite ? 'Remove from favorites' : 'Add to favorites'}
				aria-pressed={isFavorite}
			>
				<HeartIcon className='h-4 w-4' />
			</button>

			<div className='flex flex-1 justify-center'>
				<span className='truncate text-base font-semibold tracking-[-0.21px] text-foreground sm:text-lg'>{gameName}</span>
			</div>

			<PlayViewControls onFullscreen={onFullscreen} onTheaterToggle={onTheaterToggle} isTheaterMode={isTheaterMode} />
		</div>
	)
}
